import { useEffect, useState } from 'react'
import { AnchorLoader } from '@/components/AnchorLoader'

/**
 * Loader yang SENGAJA ditunda: tidak menampilkan apa pun selama `delay` ms.
 * Kalau navigasi / fetch selesai sebelum ambang (komponen ini keburu unmount),
 * loader tidak pernah muncul → terasa instan. Loader baru tampil kalau memang
 * lambat melewati ambang.
 */
export function DelayedLoader({
  delay = 350,
  label,
}: {
  delay?: number
  label?: string
}) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const t = setTimeout(() => setShow(true), delay)
    return () => clearTimeout(t)
  }, [delay])

  if (!show) return null
  return <AnchorLoader label={label} />
}
